import { MachineType } from 'models/MachineType';
import { UserShortRef } from 'models/User';

export class Machine {
    id: number;
    name: string;
    identification: string;
    serviceLife: number;
    machineType: MachineType;
    archivedDate?: Date;
    user?: UserShortRef | null;
    
    constructor (
        id:number,
        name: string,
        identification: string,
        serviceLife: number,
        machineType: MachineType,
        archivedDate?: Date
    ) {
        this.id = id;
        this.name = name;
        this.identification = identification;
        this.serviceLife = serviceLife;
        this.machineType = machineType;
        this.archivedDate = archivedDate;
    }
    static empty(): Machine {
        return { 
            id: 0,
            name: '',
            identification: '',
            serviceLife: 0,
            machineType: MachineType.empty()
        };
    }

    // the machine to preselect for the user, if one is assigned
    static assignedTo(machines: Machine[], userId?: string): Machine | undefined {
        return userId ? machines.find(m => !m.archivedDate && m.user?.id === userId) : undefined;
    }

}